import { PageView, PageViewPerformance } from '@microsoft/applicationinsights-web';

import { getReactPlugin, initApplicationInsights } from '@fora-monorepo/webapp-analytics';

import { appName, envConfig } from '../config';
import { PathKeys, pathNameVariations } from '../router/paths';
import { routeHandles } from '../router/routeHandles';
import { i18nextInstance } from '../i18n/i18n';

export const initAppInsights = () => {
  if (envConfig.applicationInsightsConnectionString) {
    const appInsights = initApplicationInsights(appName, envConfig.applicationInsightsConnectionString);
    // Add custom page names
    appInsights.addTelemetryInitializer(function (envelope) {
      // For page view events, edit the event name to easier tell apart page views in AI
      if (
        (envelope.baseType === PageView.dataType || envelope.baseType === PageViewPerformance.dataType) &&
        envelope.baseData
      ) {
        const newName = createPageViewEventName(envelope.baseData.uri);
        // Save the original name (defaults to document title, ex Administrera arbetare), should it be useful.
        // we save it in a new custom prop; documentTitle.
        if (envelope.data) envelope.data.documentTitle = envelope.baseData?.name;
        // Overwrite with new name (ex Administrera arbetare - Lägg till anställd)
        envelope.baseData.name = newName;
      }
    });
  }
};

export const reactPlugin = getReactPlugin();

/** Based on URL, construct name with title and crumb, like 'Administrera arbetare - Lägg till anställd'  */
const createPageViewEventName = (uri: string) => {
  if (uri.endsWith('/foretag') || uri.endsWith('/foretag/')) {
    return 'Landningssida';
  }

  // Get path key from last matching sub path (ex 'andra' in )
  const subPaths = uri.split(/[/?]+/);
  let pathKey: PathKeys | undefined;
  for (let i = subPaths.length - 1; i >= 0; i--) {
    const subPath = subPaths[i];
    if (subPath) {
      pathKey = (Object.keys(pathNameVariations) as Array<PathKeys>).find(key =>
        pathNameVariations[key].includes(subPath)
      );
    }
    if (pathKey) break;
  }

  if (pathKey) {
    // Always use Swedish names to group views from different languages
    const title = i18nextInstance.t(routeHandles[pathKey].title, { lng: 'sv' });
    const crumb = i18nextInstance.t(routeHandles[pathKey].crumb || '', { lng: 'sv' });
    return crumb ? title + ' - ' + crumb : title;
  } else {
    return 'Okänd sida';
  }
};
